module.exports = __webpack_public_path__ + "img/Mina-Tlaminca.c809cf80.png";